<template>
  <div v-if="isShow">
    <div class="wx_store_box mod_row_flex">
      <img class="wx_store_img" src="../../assets/icon_store.png"/>
      <div class="mod_flex_1">
        <p class="wx_store_name mod_two_lines">{{ orderDetail.hotel_name }}</p>
        <p v-if="orderDetail.address" class="mod_store_address mod_single_line">{{ orderDetail.address }}</p>
      </div>
    </div>
    <div class="order_list_box">
      <div class="order_list mod_column_flex">
        <template>
          <div class="mod_row_flex order_item">
            <div class="order_item_nights">{{orderDetail.num}} 份</div>
            <div class="mod_column_flex mod_flex_1 mod_justify_center">
              <p class="order_item_room mod_single_line">{{ orderDetail.voucher_name }}</p>
            </div>
          </div>
        </template>
        <div class="order_money_box mod_row_flex mod_align_item_center mod_justify_end">
          <div class="order_money_label">
            付款金额
            <span class="order_money_symbol">¥</span>
            <span class="order_money_text">{{ orderDetail.total_amount }}</span>
          </div>
        </div>
      </div>
    </div>

<!--    <div v-else-if="isExist === false" class="wx_pay_empty_box mod_column_flex mod_align_item_center">-->
<!--      <img src="../../assets/icon_empty.png"/>-->
<!--      <p>没有找到需要支付的订单</p>-->
<!--    </div>-->

    <van-button  v-if="Number(orderDetail.amount) !== 0" class="wx_pay_button" type="primary" @click="openWxPay">微信支付</van-button>
    <van-number-keyboard safe-area-inset-bottom />
  </div>
</template>

<script>
import {getQueryBbj} from "@/utils/modUtils";
import {Toast} from "vant";
import {getVoucherDetail, getVoucherPayInfo} from "@/services/mitu";

export default {
  name: "Voucher",
  data(){
    return{
      isShow: false,
      urlParams: {},
      orderDetail: {}
    }
  },
  mounted() {
    const user = JSON.parse(window.localStorage.getItem('userInfo'));
    console.log("user", user);
    const localWxCode = window.localStorage.getItem('wxCode')
    const _href = window.location.href
    // 获取当前url里的code
    const wxCode = getQueryBbj(_href).code
    if (wxCode && localWxCode && localWxCode !== wxCode){
      this.isShow = true;
    }
    this.parseUrl();
  },
  methods:{
    parseUrl(){
      const urlParams = getQueryBbj(window.location.href);
      if (urlParams.orderId && urlParams.payId){
        this.urlParams = urlParams;
        this.getDetail();
      }else{
        Toast.fail("当前交易不存在");
      }
    },
    getDetail(){
      getVoucherDetail({
        order_id: this.urlParams.orderId,
        pay_id: this.urlParams.payId
      }).then(res => {
        this.orderDetail = res.data;
      })
    },
    openWxPay(){
      const user = JSON.parse(window.localStorage.getItem('userInfo'));
      console.log("user", user);
      getVoucherPayInfo({
        order_id: this.orderDetail.order_id,
        openid: user.openid
      }).then(res => {
        console.log("res", res);
        this.wxPay(res.data);
      });
    },
    async wxPay(payData) {
      let that = this;
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: payData.pay.appId,
            timeStamp: payData.pay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: payData.pay.nonceStr, // 支付签名随机串，不长于 32 位
            package: payData.pay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: payData.pay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: payData.pay.paySign //
          },
          function(payRes) {
            console.log("WeixinJSBridge", payRes);
            if (payRes.err_msg == "get_brand_wcpay_request:ok") {
              that.getPayStatus();
            }
            if (payRes.err_msg == "get_brand_wcpay_request:cancel") {
              window.Toast("您取消了支付");
            }
          }
      );
    },
  }
}
</script>

<style scoped lang="less">
.wx_store_box{
  background: #FFFFFF;
  border-radius: 8px;
  margin: 10px 12px;
  .wx_store_img{
    width: 16px;
    height: 16px;
    margin: 16px 8px 0 12px;
    flex-shrink: 0;
  }
  .wx_store_name{
    font-weight: 500;
    font-size: 14px;
    color: #263341;
    line-height: 16px;
    margin: 16px 12px 4px 0;
  }
  .mod_store_address{
    height: 16px;
    font-weight: 400;
    font-size: 12px;
    color: rgba(38,51,65,0.55);
    letter-spacing: 0;
    line-height: 16px;
    margin-bottom: 16px;
  }
}
.order_list_box{
  margin: 10px 12px 0 12px;
  .order_list{
    background: #FFFFFF;
    border-radius: 8px;
    padding: 16px 12px 12px 12px;
    .order_name{
      height: 16px;
      font-weight: 500;
      font-size: 16px;
      color: #263341;
      letter-spacing: 0;
      line-height: 16px;
      margin: 16px 12px 0 12px;
    }
    .order_address{
      height: 16px;
      font-weight: 400;
      font-size: 12px;
      color: rgba(38,51,65,0.55);
      letter-spacing: 0;
      line-height: 16px;
      margin: 4px 12px 12px 12px;
    }
    .order_item{
      margin: 0 12px 16px 12px;
      .order_item_nights{
        width: 56px;
        height: 56px;
        background-image: linear-gradient(140deg, #454D61 0%, #7B859B 100%);
        border-radius: 4px;
        line-height: 56px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        flex-shrink: 0;
        margin-right: 8px;
      }
      .order_item_room{
        font-weight: 400;
        font-size: 14px;
        color: #263341;
        letter-spacing: 0;
        text-align: justify;
        line-height: 16px;
        max-width: 263px;
      }
      .order_item_room_type{
        height: 16px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(38,51,65,0.55);
        letter-spacing: 0;
        text-align: justify;
        line-height: 16px;
        max-width: 263px;
        margin-top: 4px;
      }
      .order_item_date{
        height: 12px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(38,51,65,0.55);
        letter-spacing: 0;
        text-align: justify;
        line-height: 12px;
        margin-top:8px;
      }
    }
    .order_money_box{
      height: 50px;
      background: #FFFFFF;
      border-top: 1px solid #E9EAEC;
      .order_money_label{
        height: 20px;
        font-weight: 400;
        font-size: 14px;
        color: #263341;
        text-align: right;
        line-height: 20px;
      }
      .order_money_symbol{
        height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #263341;
        text-align: right;
        line-height: 20px;
      }
      .order_money_text{
        height: 26px;
        font-weight: 500;
        font-size: 24px;
        color: #263341;
        text-align: right;
        line-height: 26px;
      }
      .order_pay_button{
        width: 88px;
        height: 32px;
        padding: 0;
        border-radius: 16px;
        z-index: 0;
      }
    }
    .order_tip{
      height: 24px;
      background: #FFFBF0;
      border-radius: 0 0 8px 8px;
      font-weight: 400;
      font-size: 10px;
      color: #FFAA2B;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;
    }
  }
}
.wx_pay_button{
  width: calc(100% - 24px);
  position: fixed;
  bottom: 12px;
  left: 12px;
  background: linear-gradient(90deg, rgba(254, 219, 109, 1) 0%, rgba(255, 202, 37, 1) 100%);
  border: none;
}
.wx_pay_empty_box {
  margin-top: 80px;
  margin-bottom: 12px;

  img {
    width: 120px;
    height: 120px;
  }

  p {
    font-weight: 400;
    font-size: 13px;
    color: rgba(38, 51, 65, 0.55);
    text-align: center;
    line-height: 24px;
  }
}
.order_one_note{
  height: 16px;
  font-weight: 500;
  font-size: 14px;
  color: #263341;
  letter-spacing: 0;
  text-align: justify;
  line-height: 16px;
  margin-bottom: 16px;
}
</style>
